<template>
  <Header />
  <div class="py-2 bg-gradient-to-b from-red-50 to-transparent w-full h-full lg:pb-2 relative">
    <div
v-if="friends.length >= 5 && $store.state.user.data.plan !== 'paid'"
      class="container min-w-full flex flex-col items-center z-25 "
>
      <button
@click="createCheckoutSession"
        class="mx-1 text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-green-600 dark:hover:bg-red-600 dark:focus:ring-green-800"
        type="button"
>
        <svg
v-if="checkoutLoading" aria-hidden="true" role="status"
          class="inline w-4 h-4 mr-1 text-gray-200 animate-spin dark:text-gray-600" viewBox="0 0 100 101" fill="none"
          xmlns="http://www.w3.org/2000/svg"
>
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
/>
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="#1C64F2"
/>
        </svg>
        Upgrade
      </button>
      <p class="text-center text-red-700 dark:text-gray-400">
        You have reached the maximum number of friends on our free tier, upgrade your plan ($10 once off) to add
        unlimited
        friends!
      </p>
    </div>

    <div v-else class="container min-w-full flex flex-col items-center z-25">
      <!-- No friends yet - show "Add your first person" -->
      <div
v-if="friends.length === 0"
        class="bg-white rounded-xl shadow-lg border border-gray-200 p-6 mb-4 max-w-md mx-auto"
>
        <div class="text-center">
          <div
            class="w-16 h-16 bg-gradient-to-br from-red-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4"
>
            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
/>
            </svg>
          </div>
          <h3 class="text-lg font-semibold text-gray-900 mb-2">Add Your First Person</h3>
          <p class="text-gray-600 text-sm mb-6">
Start building your gift planning list by adding friends and family
            members.
</p>
          <button
@click="$router.push('/friend/add')"
            class="inline-flex items-center px-6 py-3 bg-gradient-to-r from-red-500 to-pink-500 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-red-600 hover:to-pink-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-all duration-200 transform hover:scale-105"
>
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Add Someone
          </button>
        </div>
      </div>

      <!-- Has friends but under limit - show simple "Add someone" button -->
      <div v-else class="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-4">
        <div class="w-full max-w-4xl mx-auto px-2">
          <div class="flex flex-col sm:flex-row sm:items-center space-y-4 sm:space-y-0 sm:space-x-4">
            <!-- Icon and Text Content (grouped together on mobile) -->
            <div class="flex items-center space-x-4 flex-1">
              <div
                class="w-12 h-12 bg-gradient-to-br from-red-500 to-pink-500 rounded-full flex items-center justify-center flex-shrink-0"
>
                <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
stroke-linecap="round" stroke-linejoin="round"
                    d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
>
                  </path>
                </svg>
              </div>

              <!-- Text Content -->
              <div class="flex-1">
                <h3 class="text-lg font-semibold text-gray-900">Friends & Family</h3>
                <p class="text-sm text-gray-600">Add more people to your gift planning list</p>
              </div>
            </div>

            <!-- Add Button -->
            <div class="flex justify-center sm:justify-end">
              <button
@click="$router.push('/friend/add')"
                class="inline-flex items-center px-6 py-3 bg-gradient-to-r from-red-500 to-pink-500 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-red-600 hover:to-pink-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-all duration-200 transform hover:scale-105 w-full sm:w-auto justify-center sm:justify-start"
>
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
/>
                </svg>
                Add Someone
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pt-4 space-y-3">
      <hr class="w-full" />
    </div>

    <FriendList />

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import FriendList from "@/components/FriendList.vue";

import { Auth } from 'aws-amplify';

export default {
  name: "PeopleView",
  components: {
    Header,
    Footer,
    FriendList,
  },
  data() {
    return {
      checkoutLoading: false,
    }
  },
  computed: {
    friends() {
      return this.$store.state.friendMap;
    },
  },
  created() {
    Auth.currentAuthenticatedUser({
      bypassCache: true
    })
      .then((user) => {
        if (user.attributes['custom:plan'] !== this.$store.state.user.data.plan) {
          this.$store.dispatch("fetchUser", user);
        }
      }
      )
      .catch((err) => console.log(err));
  },
  methods: {
    async createCheckoutSession() {
      this.checkoutLoading = true;
      try {
        const response = await fetch('https://api.' + process.env.VUE_APP_ENVIRONMENT + '.presentplanner.co/create-checkout-session', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ email: this.$store.state.user.data.username })
        });
        const data = await response.json();
        const stripe = Stripe(process.env.VUE_APP_STRIPE_PUB_KEY);
        const result = await stripe.redirectToCheckout({ sessionId: data.id });
        if (result.error) {
          console.error(result.error.message);
        }
      } catch (error) {
        console.error("Error: ", error);
      }
    }
  },
};
</script>
